import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getRankClass'
})
export class GetRankClassPipe implements PipeTransform {

  transform(value: {rank:number, rankOld:number}, args?: any): any {
    return this.getClass(value.rank, value.rankOld);
  }
  getClass(rank: number, rankOld: number) {
    if (rank < rankOld) {
      return 'up';
    }
    if (rank > rankOld) {
      return 'down';
    }
    if (rank === rankOld) {
      return 'equal';
    }
  }
}
